import AVdxbText from './index.vue';

AVdxbText.install = app => {
  app.component(AVdxbText.name, AVdxbText);
};

export default AVdxbText;
